const $ = jQuery.noConflict();

$(document).ready(function () {

  if ($('#featured-slider').length > 0) {
    new Splide('#featured-slider', {
      arrows: false,
      easing: 'ease',
      fixedWidth: false,
      gap: 24,
      pagination: false,
      perPage: 3,
      rewind: true,
      breakpoints: {
        414: {
          fixedWidth: 376,
          pagination: true,
          perPage: 1,
        },
        991: {
          fixedWidth: 376,
          pagination: true,
          perPage: 1,
        },
        1023: {
          fixedWidth: false,
          pagination: false,
          perPage: 3,
        }
      },
    }).mount();
  }

  if ($('#events-slider').length > 0) {
    new Splide('#events-slider', {
      arrows: true,
      easing: 'ease',
      fixedWidth: false,
      gap: 24,
      pagination: true,
      perPage: 4,
      rewind: true,
      breakpoints: {
        414: {
          fixedWidth: false,
          pagination: true,
          perPage: 1,
        },
        768: {
          fixedWidth: 276,
          pagination: true,
          perPage: 2,
        },
        1023: {
          fixedWidth: 276,
          pagination: true,
          perPage: 3,
        }
      },
    }).mount();
  }

  new Splide('#social-slider', {
    arrows: false,
    easing: 'ease',
    gap: 24,
    perPage: 4,
    breakpoints: {
      599: {
        perPage: 1,
      },
      767: {
        perPage: 2,
      },
      1023: {
        perPage: 3,
      },
    },
  }).mount();

});
